// extracted by css-extract-rspack-plugin
export default {"BtnWrapper":"BtnWrapper-It7BNU","btnWrapper":"BtnWrapper-It7BNU","TextWrapper":"TextWrapper-J7l4r1","textWrapper":"TextWrapper-J7l4r1"};